import React from 'react'


const Thumbnail = ({thumbnailLink, setPdfView}) => {
  return (
    <div onClick={() => setPdfView(true)} style={{cursor:"pointer", height:"100%", display:"flex", justifyContent:"center", alignItems:"center"}}>
        <img src={thumbnailLink} style={{maxWidth:"100%", maxHeight:"100%"}} />
    </div>
  )
}

export default Thumbnail